<div class="navbar navbar-fixed-top header" id="desktop" *ngIf="showHead">
  <div class="row" style="width: 100%;">
    <div routerLink="/cp/logs" class="col-md-3" style="cursor: pointer;">
      <!-- <img src="../../../assets/images/new_logo.png" class="logo" /> -->
       <div class="logo logo1">
          <!-- PRO-VIEW ADMIN -->
                 <!-- <img src="../../../assets/images/new_logo.png" class="logo" /> -->
            <img src="../../../assets/images/admin-panel.png" 
                 class="logo" 
                 width="130" 
                 height="65" 
                 alt="Admin Panel Logo" 
                 loading="eager" />
       </div>
    </div>
    <div class="col-md-9 profile-data">
      <!-- <a *ngIf="viewDashboard" routerLink="/dashboard" class="headerLink" href="javascript:void(0)">Dashboard</a> -->
      <!-- <a *ngIf="viewDashboard" routerLink="/dashboard" class="headerLink" href="javascript:void(0)">Dashboard</a>
      <a *ngIf="viewDevices" [routerLink]="['/monitors',unitId]" class="headerLink"
        href="javascript:void(0)">Devices</a>
      <a *ngIf="viewSites" routerLink="/sites" class="headerLink" href="javascript:void(0)">Sites</a>
      <a *ngIf="viewCloudInfra" routerLink="/cloud-infrastructure" class="headerLink" href="javascript:void(0)">Cloud
        Infrastructure</a> -->
      <!-- View -->
      <!-- <a [matMenuTriggerFor]="viewMenu"
        href="javascript:void(0)"
        class="headerLink">VIEW
      </a>
      <mat-menu #viewMenu="matMenu">
        <a mat-menu-item *ngIf="viewDevices" [routerLink]="['/monitors',unitId]">Devices</a>
        <a mat-menu-item *ngIf="viewSites" routerLink="/sites">Sites</a>
        <a mat-menu-item *ngIf="viewCloudInfra" routerLink="/cloud-infrastructure">Cloud Infrastructure</a>
      </mat-menu>  -->
      <!-- Camera Server Link button -->
      <!-- <a *ngIf="showCameraServer && (viewCameraConfig || editCameraConfig || editEc2Config)" 
        [matMenuTriggerFor]="cameraServerMenu" 
        href="javascript:void(0)"
        class="headerLink">Configuration</a>
      <mat-menu #cameraServerMenu="matMenu">
        <a mat-menu-item routerLink="/camera-server/site-list">Site</a>
        <a mat-menu-item routerLink="/camera-server/camera-list">Camera</a>
        <a mat-menu-item [matMenuTriggerFor]="useFulLinks">Useful Links
          <span class="arrow-caret">&#9658;</span>
        </a>
        <a mat-menu-item routerLink="/camera-server/ec2" *ngIf="configService.isFeatureEnabled('ec2') && editEc2Config">EC2</a>
        <a mat-menu-item routerLink="/camera-server/footage-list">Download Footage</a>
      </mat-menu>

      <mat-menu #useFulLinks="matMenu">
        <a mat-menu-item href="https://portal.pro-vigil.info/" target="_blank">Customer Portal</a>
        <a mat-menu-item href="https://pro-safe-admin.pro-vigil.info/" target="_blank">Pro-Safe Admin</a>
        <a mat-menu-item href="https://me-admin.pro-vigil.info/" target="_blank">ME Admin</a>
        <a mat-menu-item href="https://pro-vigil.my.salesforce.com/a1Y?fcf=00Bo0000004jHtT" target="_blank">Salesforce</a>
        <a mat-menu-item href="https://accounts.cradlepointecm.com/?redirect_url=https%3A%2F%2Faccounts.cradlepointecm.com#/login" target="_blank">Netcloud Cradlepoint</a>
        <a mat-menu-item href="https://pro-vigil.zendesk.com/agent/filters/360128784112" target="_blank">Zendesk</a>
        <a mat-menu-item href="https://app.zuperpro.com/dashboard" target="_blank">Zuper</a>
        <a mat-menu-item href="http://workspace.pro-vigil.com:777/ivigil-shield/manualSyncforPortal.jsp" target="_blank">Cockpit-1</a>
        <a mat-menu-item href="http://workspace.pro-vigil.com:777//ivigil-shield//updatepotential.jsp"  target="_blank">Cockpit-2</a>
        <a mat-menu-item href="http://ivigiltraining.pro-vigil.info:8090/ivigil-sitessync/siteshostingserver.jsp" target="_blank">I-Vigil Sync</a>
      </mat-menu> -->

      <!-- <button *ngIf="viewHelp" mat-button [matMenuTriggerFor]="menu" class="headerLink">HELP</button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item [matMenuTriggerFor]="subMenu">
          <span class="arrow-caret">&#9664;</span>
          Documentation</button>
      </mat-menu>

      <mat-menu #subMenu="matMenu" xPosition="before">
        <button mat-menu-item [matMenuTriggerFor]="manuals">
          <span class="arrow-caret">&#9664;</span>
          <div class="button-text">
              Manuals
          </div>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="projectMenu">
          <span class="arrow-caret">&#9664;</span>
          <div class="button-text">
            <div>Project Management &</div>
            <div>Site Enablement</div>
          </div>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="technicalServices" class="multiline">
          <span class="arrow-caret">&#9664;</span>
          Technical Services
        </button>
        <button mat-menu-item [matMenuTriggerFor]="fieldServices" class="multiline">
          <span class="arrow-caret">&#9664;</span>
          Field Services
        </button>
      </mat-menu>

      <mat-menu #manuals="matMenu" xPosition="before">
        <button mat-menu-item (click)="openLink(urls.manuals.proFitUserManual)">
          <div class="button-text">
              Pro-Fit User Manual
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.manuals.repeatOutage)">
          <div class="button-text">
            Repeat Outage Process
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.manuals.solarscriptManual)">
          <div class="button-text">
            MDX Solar Script Manual
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.manuals.mdcHelp)">
          <div class="button-text">
            MDC Solar Script Manual
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.mdcsetup)">
          <div class="button-text">
            <div>MDC Setup and Configuration</div>
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.manuals.itarSiteConfiguration)">
          <div class="button-text">
            ITAR Site Configuration
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.manuals.plannedMaintenance)">
          <div class="button-text">
            Planned Maintenance Process
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.manuals.projectManagement)">
          <div class="button-text">
            Project Management Process
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.manuals.siteConfigurationUserManual)">
          <div class="button-text">
            Site Configuration User Manual
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.manuals.outdoorLab)">
          <span class="button-text">
            Outdoor lab process
          </span>
        </button>
      </mat-menu>

      <mat-menu #mobileSites="matMenu" xPosition="before">
        <button mat-menu-item [matMenuTriggerFor]="mdx" id="mdxButton">
          <span class="arrow-caret">&#9664;</span>
          <div class="button-text">
            MDX
          </div>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="mdc" id="mdcButton">
          <span class="arrow-caret">&#9664;</span>
          <div class="button-text">
            MDC
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.mobileStagewise)">
          <div class="button-text">
            <div>Stage Wise Mobile Site</div>
            <div>Onboarding Process</div>
          </div>
        </button>
      </mat-menu>

      <mat-menu #projectMenu="matMenu" xPosition="before">
        <button mat-menu-item [matMenuTriggerFor]="mobileSites" id="mobileSites">
          <span class="arrow-caret">&#9664;</span>
          <div class="button-text">
            Mobile Sites
          </div>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="fixedSites" id="fixedSites">
          <span class="arrow-caret">&#9664;</span>
          <div class="button-text">
            Fixed Sites
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.equipmentConfigStandards)">
          <div class="button-text">
            <div>Equipment and</div>
            <div>Configuration Standards</div>
          </div>
        </button>


        <button mat-menu-item (click)="openLink(urls.procedures)">
          <div class="button-text">
            <div>Standard Device</div>
            <div>Configuration Procedures</div>
          </div>
        </button>

        <button mat-menu-item (click)="openLink(urls.siteEnableProcess)">
          <div class="button-text">
            <div>Site Enablement Team</div>
            <div>Process</div>
          </div>
        </button>

        <button mat-menu-item (click)="openLink(urls.x410UIstandardConfig)">
          <span class="button-text">
              <span>X-410 UI Standard Configuration</span>
          </span>
        </button>
        
        <button mat-menu-item (click)="openLink(urls.firmwareUpgrade)">
          <div class="button-text">
            Firmware Upgrade
          </div>
        </button>

        <button mat-menu-item (click)="openLink(urls.provigilOnPrem)">
          <div class="button-text">
            Pro-Vigil On-Prem
          </div>
        </button>

        <button mat-menu-item (click)="openLink(urls.pepLinkRouter)">
          <span class="button-text">
            <span>MDP PepLink Docs</span>
          </span>
        </button>

      </mat-menu>

      <mat-menu #technicalServices="matMenu" xPosition="before">
        <button mat-menu-item [matMenuTriggerFor]="outageMenu">
          <span class="arrow-caret">&#9664;</span>
          <div class="button-text">
            <div>Outage Resolution</div>
            <div>Procedures</div>
          </div>
        </button>
        <button mat-menu-item (click)="mdxDeviceData()" class="subLink">
          <div class="button-text">
            <div>Email MDX Settings</div>
          </div>
        </button>

        <button mat-menu-item (click)="allSiteUptime()" class="subLink" *ngIf="showUPtime">
          <div class="button-text">
            <div>Email all Sites</div>
            <div>Uptime Report (Last 30 days)</div>
          </div>
        </button>

        <button mat-menu-item class="subLink" (click)="openLink(urls.mdcTroubleshoot)">
          <div class="button-text">
            <div>MDC Troubleshooting Steps</div>
          </div>
        </button> -->

        <!-- <button mat-menu-item class="subLink" (click)="routerInfoReport()">
          <div class="button-text">
            <div>Router Info Report</div>
          </div>
        </button> -->

      <!-- </mat-menu> -->

      <!-- <mat-menu #outageMenu="matMenu" xPosition="before">
        <button mat-menu-item (click)="openLink(urls.remoteResolution)">
          Remote Resolution
        </button>
      </mat-menu>

      <mat-menu #fieldServices="matMenu" xPosition="before">
        <button mat-menu-item class="subLink" (click)="openLink(urls.fieldService.batteryOrder)">
          <div class="button-text">
            <div>Battery Order Process</div>
          </div>
        </button>
        <button mat-menu-item class="subLink" (click)="openLink(urls.fieldService.techLink)">
          <div class="button-text">
            <div>TechLink Process</div>
          </div>
        </button>
        <button mat-menu-item class="subLink" (click)="openLink(urls.fieldService.heatMap)">
          <div class="button-text">
            <div>Heat Map Process</div>
          </div>
        </button>
        <button mat-menu-item class="subLink" (click)="openLink(urls.fieldService.csmTicket)">
          <div class="button-text">
            <div>CS/CSM Ticket Process</div>
          </div>
        </button>
        <button mat-menu-item class="subLink" (click)="openLink(urls.fieldService.fieldNation)">
          <div class="button-text">
            <div>Field Nation Work Order</div>
            <div>Process</div>
          </div>
        </button>
        <button mat-menu-item class="subLink" (click)="openLink(urls.fieldService.shippingParts)">
          <div class="button-text">
            <div>Shipping Parts Process</div>
          </div>
        </button>
        <button mat-menu-item class="subLink" (click)="openLink(urls.fieldService.asdProcess)">
          <div class="button-text">
            <div>ASD Process</div>
          </div>
        </button>
      </mat-menu>

      <mat-menu #mdx="matMenu" xPosition="before">
        <button mat-menu-item (click)="openLink(urls.mdx.siteEnableprocess)">
            MDX Site Enablement Process
        </button>
		    <button mat-menu-item (click)="openLink(urls.mdx.onboardingProcess)">
            MDX Onboarding Process
        </button>
		    <button mat-menu-item (click)="openLink(urls.mdx.preFlight)">
            MDX Pre-Flight Process
        </button>
      </mat-menu>

      <mat-menu #mdc="matMenu" xPosition="before">
        <button mat-menu-item (click)="openLink(urls.mdc.siteEnableprocess)">
            MDC Site Enablement Process
        </button>
        <button mat-menu-item (click)="openLink(urls.mdc.onboardingProcess)">
            MDC Onboarding Process
        </button>
        <button mat-menu-item (click)="openLink(urls.mdc.preFlight)">
            MDC Pre-Flight Process
        </button>
      </mat-menu>

      <mat-menu #fixedSites="matMenu" xPosition="before">
        <button mat-menu-item (click)="openLink(urls.fixed.networkSetup)">
          <div class="button-text">
            <div>Fixed Site Installations -</div>
            <div>Network Setup</div>
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.fixed.onBoarding)">
          <div class="button-text">
            <div>Fixed Site Onboarding -</div>
            <div>Process</div>
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.fixed.enablement)">
          <div class="button-text">
            <div>Fixed Site Enablement -</div>
            <div>Process</div>
          </div>
        </button>
        <button mat-menu-item (click)="openLink(urls.fixed.stageWise)">
          <div class="button-text">
            <div>Stage Wise Fixed Site</div>
            <div>Onboarding Process</div>
          </div>
        </button>
      </mat-menu> -->

      <a *ngIf="hasAdminRole || hasViewUserRole || hasEditUserRole"
        [matMenuTriggerFor]="proviewMenu"
        href="javascript:void(0)"
        class="headerLink um-user-menu-trigger">User
      </a>
      <mat-menu #proviewMenu="matMenu"
        yPosition="below"
        xPosition="before"
        class="um-proview-menu"
        panelClass="um-proview-menu-panel">
        <button mat-menu-item type="button" routerLink="/cp/logs" routerLinkActive="um-menu-item-active">
          Activity Insights
        </button>
        <button mat-menu-item type="button" routerLink="/cp/user-management" routerLinkActive="um-menu-item-active">
          Management
        </button>
        <button mat-menu-item type="button" routerLink="/cp/archive-dashboard" *ngIf="configService.isSuperAdmin()" routerLinkActive="um-menu-item-active">
          Archive Dashboard
        </button>
        <button mat-menu-item type="button" routerLink="/cp/new-tips" *ngIf="configService.isSuperAdmin()" routerLinkActive="um-menu-item-active">
          New Tips
        </button>
        <button mat-menu-item type="button" routerLink="/jira-reports" *ngIf="configService.isSuperAdmin()" routerLinkActive="um-menu-item-active">
          JIRA Reports
        </button>
      </mat-menu>
      <div *ngIf="hasAdminRole || userMgmt">
        <div class="nav-item btn-rotate admin-dropdown" ngbDropdown placement="bottom-left" display="dynamic" dropdownClass="admin-dropdown-left">
          <a class="headerLink settings" ngbDropdownToggle id="navbarDropdownMenuLink">
            Admin
          </a>
          <div ngbDropdownMenu aria-labelledby="navbarDropdownMenuLink" class="dropdown-menu">
            <div>
              <button ngbDropdownItem (click)="navigatePrivilege()">Privilege
              </button>
            </div>
            <div>
              <button ngbDropdownItem (click)="navigateRoles()">Roles
              </button>
            </div>
            <div>
              <button ngbDropdownItem (click)="navigateUserManagement()">User
                Management
              </button>
            </div>
            <!-- <div *ngIf="readOnlyUser || accountConfigurations">
              <button ngbDropdownItem (click)="navigateAccountConfiguration()">Account Configuration
              </button>
            </div>
            <div *ngIf="zendeskComments">
              <button ngbDropdownItem (click)="navigateZendeskComments()">Zendesk Comments
              </button>
            </div>
            <div *ngIf="readOnlyUser">
              <button ngbDropdownItem (click)="downloadExcelTrigger()">Active Axis Camera Data
              </button>
            </div> -->
          </div>
        </div>
      </div>
      <div class="text-right cursor">
        <div class="nav-item btn-rotate profile-dropdown" ngbDropdown placement="bottom-left">
          <a class="nav-link anchor" ngbDropdownToggle id="navbarDropdownMenuLink">
            <img class="user-image" [src]="userImage" />
          </a>
          <div ngbDropdownMenu aria-labelledby="navbarDropdownMenuLink" class="dropdown-menu">
            <p ngbDropdownItem> <i class="fa fa-user-circle icon-size"></i><span class="font"> {{userEmail}} </span></p>
            <button ngbDropdownItem (click)="logout()"> <i class="fa fa-sign-out icon-size"></i><span class="font"> Logout </span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div><i *ngIf="isShow" (click)="gotoTop()" class=' button fas fa-caret-square-up' style=' font-size:30px;   opacity: .8;
color: #f16e02;'></i></div>